var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement } from '../typescript/TSXDomParse';
export default function NavTitle(_a) {
    var _b;
    var title = _a.title, level = _a.level, url = _a.url;
    var hasLink = ((_b = url === null || url === void 0 ? void 0 : url.length) !== null && _b !== void 0 ? _b : 0) > 0;
    return (DOMcreateElement("a", __assign({}, (hasLink ? { href: url } : {}), { className: "nav-link nav-title level-" + level + (hasLink ? 'has-link' : '') }), title));
}
